export default '0.8.8.7'; // Show User Phone Number in Profile (after indirect login)
// export default '0.8.8.6'; // Small tweaks to compression code
// export default '0.8.8.5'; // Delay compression/store of Redux state until relative quaiesence
// export default '0.8.8.4'; // Compress Redux state that we save in case of browser refresh
// export default '0.8.8.3'; // Improve RefContact Description UI
// export default '0.8.8.2'; // Clean up alignment of Date Range Picker, etc, from CRM-829.
// export default '0.8.8.1'; // Debug API Token Request API
// export default '0.8.8.0'; // Add API Token Request API
// export default '0.8.7.32'; // Clean up versions of some js packages and remove use of @mui/lab
// export default '0.8.7.31'; // Don't load AppUser of AppUserExt unless it's not null
// export default '0.8.7.30'; // Migrate to using AppUserExt
// export default '0.8.7.29'; // Set leadTemperature of new Prospect correctly in Redux
// export default '0.8.7.28'; // Enhace reliabiliity of transferring Client Ownership
// export default '0.8.7.27'; // First pass of logging to diagnose missing Prospects
// export default '0.8.7.26'; // Tune the appearance of Dropdown Editor
// export default '0.8.7.25'; // Use useEffect rather than exporting state setter
// export default '0.8.7.24'; // Uninstall modules that were crashing Azure DevOps build
// export default '0.8.7.23'; // Much nicer adding/deleting/reordering of Dropdown Items
// export default '0.8.7.22'; // Fix saving of multiple dropdown defaults
// export default '0.8.7.21'; // Special handling of Phone-or-Email requirement
// export default '0.8.7.20'; // Enhanced highlighting of required fields in NewProspect page
// export default '0.8.7.19'; // Support user-specified default Communication Type and Referral Type
// export default '0.8.7.18'; // Highlight required fields in NewProspect page
// export default '0.8.7.17'; // Enable autoselect of Facility dropdownn if only one option
// export default '0.8.7.16'; // Big overhaul of CallRail setup
// export default '0.8.7.15'; // Better SMS Alerts for new/changed Tasks
// export default '0.8.7.14'; // Better Updating of changed User name
// export default '0.8.7.13'; // Use synchronous Twilio messaging
// export default '0.8.7.12'; // Support User phone numbers and editing them
// export default '0.8.7.11'; // Enhance the deletion (by SuperAdmin) of unafilliated contacts
// export default '0.8.7.10'; // Support the deletion, by UI or SuperAdmin of unafilliated contacts
// export default '0.8.7.9'; // Extend support for Contact-free Referral Companies to NewCompany dialog
// export default '0.8.7.8'; // Add support for creating Contact-free Referral Companies
// export default '0.8.7.7'; // Add NewUnaffiliatedContact button to Contacts list page
// export default '0.8.7.6'; // Better unafilliated contact creation from ReferralPage and ReferralForm
// export default '0.8.7.5'; // Better unafilliated contact creation from NewLead modal
// export default '0.8.7.4'; // Set Contact field of ReferralSelectionHierarchy to newly created unaffiliated Contact
// export default '0.8.7.3'; // Good initial support for Unaffiliated Contacts in ReferralSelectionHierarchy
// export default '0.8.7.2'; // Make Company Name of Unaffiliated contacts unclickable
// export default '0.8.7.1'; // In client sync, don't require that client have a referral
// export default '0.8.7.0'; // Add initial support for Unaffiliated Referral Contacts
// export default '0.8.6.6'; // Further tweak client downloading
// export default '0.8.6.4'; // Add client downloading
// export default '0.8.6.3'; // Fix CRM-791 by correcting field name within Redux payload
// export default '0.8.6.2'; // Fix BirthDate representation in VOB Info
// export default '0.8.6.1'; // Add webhook for CallRail Form submission
// export default '0.8.6.0'; // Add webhook for CallRail Form submission
// export default '0.8.5.13'; // Finish work on CRM-790 by renaming function
// export default '0.8.5.12'; // Address CRM-790 by augmenting personDDict in bigDescrip
// export default '0.8.5.11'; // Address CRM-790 by augmenting personsToAdd in bigDescrip
// export default '0.8.5.10'; // Start debugging for CRM-790
// export default '0.8.5.9'; // Better feedback on Client Upload
// export default '0.8.5.8'; // Add better Phones plus Sex and Birthdate to Clients Upload
// export default '0.8.5.7'; // Fix Patch code for changing client name
// export default '0.8.5.6'; // Fix causes of NULL FirmType in DB
// export default '0.8.5.5'; // Escape Email
// export default '0.8.5.4'; // Add Email to Firm2FirmVisibility
// export default '0.8.5.3'; // Add DB table ReferralBackfillAction
// export default '0.8.5.2'; // Fix column name bug in deletion
// export default '0.8.5.1'; // Remove Facility from TreatmentProgram
// export default '0.8.5.0'; // Move FirmType from Firm to Firm2FirmVisibility
// export default '0.8.4.7'; // Eliminate use of 'Educational Consultancy'
// export default '0.8.4.6'; // Avoid 500 Error looking for unprocessed CallRail calls
// export default '0.8.4.5'; // Fix 'deletion' of RefContacts
// export default '0.8.4.4'; // Implement WebSocket portion of Referral editing; fix various small bugs
// export default '0.8.4.3'; // Add Cancel button to Referral Page's 4-level hierarchy
// export default '0.8.4.2'; // Modify Referral Page to use usual 4-level hierarchy
// export default '0.8.4.1'; // Fix glitch in adding new contact from NewReferralOrgModal
// export default '0.8.4.0'; // Add ability to add ReferralInfo after Client exists
// export default '0.8.3.4'; // Fix on-the-fly creation of RefContact from NewProspect page
// export default '0.8.3.3'; // Disable most autofill
// export default '0.8.3.2'; // Add Memo for failed Client PATCH
// export default '0.8.3.1'; // Don't lose Prospect Sex in UI
// export default '0.8.3.0'; // Tons of React library upgrading
// export default '0.8.2.27'; // Use Recharts for TopReferralSources chart
// export default '0.8.2.26'; // Use @mui/lab/DatePicker, using it for random date range on home page
// export default '0.8.2.25'; // Remove apparent Task duplication due to MarkComplete/Reopen
// export default '0.8.2.24'; // Support dismissibility of New Task dialog
// export default '0.8.2.23'; // Fix spots where we assume a Dictionary Key
// export default '0.8.2.22'; // Sort Activities Logged graphic by count
// export default '0.8.2.21'; // Allow more Top Referral Sources
// export default '0.8.2.20'; // Fix a missed Outreach.Firm name change
// export default '0.8.2.19'; // Widen jobTitleSpan, etc.
// export default '0.8.2.18'; // Don't add 'blank' ExtraInfo to DB
// export default '0.8.2.17'; // Rename Outreach.Firm to OwningFirm to avoid EF confusion
// export default '0.8.2.16'; // Rename Outreach.Firm to OwningFirm to avoid EF confusion
// export default '0.8.2.15'; // Rename PhoneOwnership.Firm to OwningFirm to avoid EF confusion
// export default '0.8.2.14'; // Rename ExtraInfo.Firm to InfoFirm and Case_Deleted to DischargeCase_Deleted to avoid EF confusion
// export default '0.8.2.13'; // Rename FirmContact.Firm to FirmContact.ReferralFirm to avoid EF confusion
// export default '0.8.2.12'; // Fix SuperAdmin User Login
// export default '0.8.2.11'; // Fix Activity Report Note.FirmId Ref
// export default '0.8.2.10'; // Rename Discharge.Case to Discharge.DischargeCase to avoid EF confusion
// export default '0.8.2.9'; // Less alarming logging about initializing Users table
// export default '0.8.2.8'; // Remove assumption that every phone number has a roles value
// export default '0.8.2.7'; // Fix Create vs Update for FirmTwilioInfo
// export default '0.8.2.6'; // Force Twilio Outgoing Phone to be +1nnnnnnnnnn
// export default '0.8.2.5'; // Fixed confused Dapper SQL
// export default '0.8.2.4'; // Clean up Note column names and semantics
// export default '0.8.2.3'; // Avoid compiler warning
// export default '0.8.2.2'; // Handle user declining sandbox invitation a little more gracefully
// export default '0.8.2.1'; // Implement sandboxed filesystem backing for Redux
// export default '0.8.1.0'; // Support deactivation of Accounts and Demos
// export default '0.8.0.2'; // Alphabetize Account names in CallRail Registration
// export default '0.8.0.1'; // Did a ton of work without ever changing version number; Add nicer CallRail Registration
// export default '0.7.7.3'; // Finished fixing the CallRail bug encountered by Fullbrook
// export default '0.7.7.2'; // Don't show play widget when CallRail Call has no URL
// export default '0.7.7.1'; // Add Logging for CallLog Filter bug fix
// export default '0.7.7.0'; // Add Column hide/reorder on Leads page
// export default '0.7.6.14'; // Fix bug in date filtering on Call Log page (api request)
// export default '0.7.6.13'; // New effort on enumeration of 'unproductive' RefCos that have Outreaches
// export default '0.7.6.12'; // Add enumeration of 'unproductive' RefCos that have Outreaches
// export default '0.7.6.11'; // Add diagnostic feedback for deleting 'unproductive' RefCos from Account
// export default '0.7.6.10'; // Include SuperAdmin ability to delete 'unproductive' RefCos from Account
// export default '0.7.6.9'; // Make sure to save Notes with newly assigned NoteId
// export default '0.7.6.8'; // Store saved Notes on Leads into Redux
// export default '0.7.6.7'; // Avoid NULLs in required Inquiry fields
// export default '0.7.6.6'; // Add Temperature field to Inquiry/Lead
// export default '0.7.6.5'; // During Firm Upload, support new Firm Types
// export default '0.7.6.4'; // During Firm Upload, don't match with non-Provider Firm
// export default '0.7.6.3'; // 90% fix for Note editing issues
// export default '0.7.6.2'; // Fix ReduxLoader bug where completionFunc might not be called
// export default '0.7.6.1'; // Small deletion-related fix
// export default '0.7.6.0'; // Merge in Call Log Actions, plus a deletion-related fix
// export default '0.7.5.1'; // A couple deletion-related fixes
// export default '0.7.5.0'; // Add ability to delete Clients
// export default '0.7.4.1'; // Small bug fixes: 1) No F2FV in Accounts; 2) weird single-refCo bug in New Lead Modal
// export default '0.7.4.0'; // Four-tiered Referral Type dropdowns and all the support for that
// export default '0.7.3.1'; // Actually save changed firmType or firmName to DB
// export default '0.7.3.0'; // Add Temperature for RefCos and RefContacts
// export default '0.7.2.14'; // Faster implementation of persons slice
// export default '0.7.2.13'; // Faster fetch of clientsInfo
// export default '0.7.2.12'; // Comment out 0.7.2.11 logging
// export default '0.7.2.11'; // Add some debug logging
// export default '0.7.2.10'; // Fix saving of VoB info to DB
// export default '0.7.2.9'; // Remove gratuitous (and possibly duplicate) IDs
// export default '0.7.2.8'; // Simplify some styles
// export default '0.7.2.7'; // If creating an initial VobForm for an existing client, save it immediately
// export default '0.7.2.6'; // Add header to VobForms dialog, and improve formatting
// export default '0.7.2.5'; // Feedback for saving Vob Form
// export default '0.7.2.4'; // Lots of changes for Multiple Vob Forms
// export default '0.7.2.3'; // Return empty object for /api/person/<personId>/vobFormInfo when there is none
// export default '0.7.2.2'; // When calling addFirmContact, make sure to bundle the arguments
// export default '0.7.2.1'; // After [PUT] /api/inquiry, make sure state contains DateTime rather than string
// export default '0.7.2.0'; // Add Referral info to NewLeadForm and LeadPage
// export default '0.7.1.7'; // Handle nulls in address fields of Case Page
// export default '0.7.1.6'; // Fix sense of test for BDay in New Prospect submission
// export default '0.7.1.5'; // use birthdateKludge to replace 0001-01-01 for admissionDate and dischargeDate
// export default '0.7.1.4'; // use birthdateKludge to replace 0001-01-01 for admissionDate and dischargeDate
// export default '0.7.1.3'; // default to birthdateKludge when have really old dDay when updating client
// export default '0.7.1.2'; // default to birthdateKludge when updating client
// export default '0.7.1.1'; // handle validation of 'null' Zip code
// export default '0.7.1.0'; // Introduce 'ThinReferral' to speed up loading of Referral Contacts
// export default '0.7.0.24'; // Truncate 'Days Since Contact' to whole number
// export default '0.7.0.23'; // Move 'Call Log' to top of NavBar, and give it a filter icon
// export default '0.7.0.22'; // Don't load in all a company's referrals for Case Page with referral from that company
// export default '0.7.0.21'; // Add some logging to start getting a handle on slow Case loading
// export default '0.7.0.20'; // Add support for uploading Clients from spreadsheet
// export default '0.7.0.19'; // Use null, rather than 0 or '' for unknown or unchanged BDay
// export default '0.7.0.18'; // Fix arg to setFirmDropdowns
// export default '0.7.0.17'; // Fix typo that caused visual duplication of Activity Items when you edited them
// export default '0.7.0.16'; // Fix a couple bugs in Reports
// export default '0.7.0.15'; // Even better test code for CallRail call grouping
// export default '0.7.0.14'; // Slightly better test code for CallRail call grouping
// export default '0.7.0.13'; // Add more test code for CallRail call grouping
// export default '0.7.0.12'; // Add test code for CallRail call grouping
// export default '0.7.0.11'; // Better widths in ActivityLoggingPanel, so Buttons never outside frame
// export default '0.7.0.10'; // Provide legal default Discharge Date for new Prospects
// export default '0.7.0.9'; // Produce better dates for grouped calls from C#
// export default '0.7.0.8'; // Convert string to date in grouping by date
// export default '0.7.0.7'; // Handle date on which there are no calls better
// export default '0.7.0.6'; // Make sure Tasks have resolved dates
// export default '0.7.0.5'; // Include a missing 'this.store.dispatch'
// export default '0.7.0.4'; // Always provide argument to buildCaseApiStruct()
// export default '0.7.0.3'; // Fix small date-related bugs
// export default '0.7.0.2'; // Default BDay of new User to null, rather than '0'
// export default '0.7.0.1'; // Proper time math in converting Lead to Prospect
// export default '0.7.0.0'; // Incorporate Redux Toolbox. Use Luxon DateTime. Fix several time issues.
// export default '0.6.8.5'; // Far nicer Date and Time Pickers, date strings in Redux
// export default '0.6.8.4'; // Make sure moment is loaded
// export default '0.6.8.3'; // Fix insurance sync null issue
// export default '0.6.8.2'; // (re-)Disable automatic key generation
// export default '0.6.8.1'; // Stable alphabetical sort of Facilities in Referral Report
// export default '0.6.8.0'; // Well-functioning Referral Report
// export default '0.6.7.0'; // Fully functioning Standard Upload
// export default '0.6.6.4'; // Fix a null.trim() bug
// export default '0.6.6.3'; // Fully functional Charlie Health uploading
// export default '0.6.6.2'; // Support WebLinks and multiple Emails per Person
// export default '0.6.6.1'; // Add Email2 and Email3 to Person record in DB
// export default '0.6.6.0'; // Add table PersonWebLink to DB
// export default '0.6.5.14'; // New Accounts will have Educational Consultant (rather than Consultancy) in dropdown
// export default '0.6.5.13'; // Save Context changes intermittently during DeleteUnownedPhoneNumbersAndAddresses
// export default '0.6.5.12'; // Enhance usefulness of Account Upload and Deletion tracing
// export default '0.6.5.11'; // Add Prefix and Suffix to Person record
// export default '0.6.5.10'; // Add ability for SuperAdmin to change User's passwords
// export default '0.6.5.9'; // Add Better CallRail logging
// export default '0.6.5.8'; // Guard against double-insertion into a sorted list
// export default '0.6.5.7'; // Add CallDuration to DB rep of CallRail call
// export default '0.6.5.6'; // Try to avoid a pointless exception on CreatedAtRoute
// export default '0.6.5.5'; // Expect a string (not int) for recording_duration in CallRail Webhook
// export default '0.6.5.4'; // Add more Memo "Logging" for CallRail Webhook
// export default '0.6.5.3'; // Remove react-perfect-scrollbar
// export default '0.6.5.2'; // Display referrals by category. Add more columns to client table
// export default '0.6.5.1'; // Fix one manifestation of the upper/lowerCase email address bug
// export default '0.6.5.0'; // Add Extension to PhoneNumber
// export default '0.6.4.9'; // Represent call duration as an int in DB
// export default '0.6.4.7'; // Since it never changes, shouldShowFacilityChooser should not be a state variable
// export default '0.6.4.6'; // Client-side logging to try to smoke out the invisible-phoneNumber bug
// export default '0.6.4.5'; // Don't call Sync server when there's no sync setup
// export default '0.6.4.3'; // Add logging to try to diagnose missing phone numbers
// export default '0.6.4.2'; // More careful handling of edge-case CallRail calls
// export default '0.6.4.1'; // Fix typo and reduce logging
// export default '0.6.4.0'; // True recursion, with Promises, in ReduxLoader
// export default '0.6.3.0'; // In Dashboard, Show all Unassigned. Broadcast all Task changes
// export default '0.6.2.1'; // Finish initial implementation of CallRail funtionality and testability
// export default '0.6.2.0'; // Implement CallRail funtionality and testability
// export default '0.6.1.1'; // Show Firm Id in System Info panel
// export default '0.6.1.0'; // Add Case/Contact page support for CallRail calls; Add Documents/Notes on Leads
// export default '0.6.0.9'; // Fix bug in bigCaseDescrip loading (was skipping a lot of stuff)
// export default '0.6.0.8'; // Faster loading of Case Page
// export default '0.6.0.7'; // In ClickAwayTextField let 'Enter' do the save, too
// export default '0.6.0.6'; // Get lots of Person cross-user updating working again
// export default '0.6.0.5'; // De-require Preferred Name and Job Title
// export default '0.6.0.4'; // Fix bug in statusDict initialization
// export default '0.6.0.3'; // Fix (?) ClickAwayTextField functionality
// export default '0.6.0.2'; // Faster access to Task info
// export default '0.6.0.1'; // Exclude 'Removed' Users from 'Activities Logged' Chart
// export default '0.6.0.0'; // Greatly sped up login experience
// export default '0.5.9.4'; // Several speedups to bigDescrip computation
// export default '0.5.9.3'; // Hopefully fix some branch/merge issues
// export default '0.5.9.2'; // Fix not-in-dictionary bug in DapperAccess.CreateTasksAccomplishedList()
// export default '0.5.9.1'; // Use Dapper to compute info for Top Referrer Firms chart
// export default '0.5.9.0'; // Use Dapper to compute info for Tasks Accomplished chart
// export default '0.5.8.9'; // Enhance (slightly) the Demos and Accounts pages
// export default '0.5.8.8'; // Clean up the LogIn page
// export default '0.5.8.7'; // For Inquiries Page, assume you don't need to re-fetch
// export default '0.5.8.6'; // Make version number visible to User
// export default '0.5.8.5'; // Add Title Line to TimingRecorder output
// export default '0.5.8.4'; // Improved, but not perfect, ClickAway behavior
// export default '0.5.8.3'; // fixed a severe bug in Emergency Contact page, which crashed if you edited Name or Email
// export default '0.5.8.2'; // Honed DB Footprint code
// export default '0.5.8.1'; // Don't pre-select 'Mobile' in New Ed Consult Modal
// export default '0.5.8.0'; // Release Searchable Contacts
// export default '0.5.7.8'; // Incorporate 'Educational Consultancy' into menus
// export default '0.5.7.7'; // When converting Lead to Prospect, Conver Notes
// export default '0.5.7.6'; // Functioning basic Searchable Contacts demo
// export default '0.5.7.5'; // Disable EMR Facility auto-select
// export default '0.5.7.4'; // Include enhanced Inquiries page, CRM-404
// export default '0.5.7.3'; // Hide the EMR-supporting kludge buttons
// export default '0.5.7.2'; // Better version of Facility Auto-select
// export default '0.5.7.1'; // Auto-select unique Facility
// export default '0.5.7.0'; // Force clients to have phone numbers, completing sync functionality
// export default '0.5.6.9'; // New version just to test chron job deployment
// export default '0.5.6.8'; // Kludge default BirthDate to accomodate EMR
// export default '0.5.6.7'; // Don't require case to have referral
// export default '0.5.6.6'; // Hide the CallRailCall DB Patching Button
// export default '0.5.6.5'; // For CallRail Calls, store Other Party in the DB
// export default '0.5.6.4'; // Add SuperAdmin facility to download Clients of a certain Status
// export default '0.5.6.3'; // Add Email Alert for Task assignment
// export default '0.5.6.2'; // Add support for redux update deleting Inquiries
// export default '0.5.6.1'; // Add support for redux update for new Inquiries
// export default '0.5.6.0'; // Add support for Redux updating
// export default '0.5.5.7'; // Simplify (slightly) manual creation of CrmContext
// export default '0.5.5.6'; // Better HTML in Email Alerts
// export default '0.5.5.5'; // Make Email notification work on Release, and include some HTML
// export default '0.5.5.4'; // Get Email notification of new leads working again
// export default '0.5.5.3'; // Cleaner handling of page unload
// export default '0.5.5.2'; // Log out when closing browser tab
// export default '0.5.5.1'; // Display Office Phone number in Referral Company page
// export default '0.5.5.0'; // Add Notes to Inquiry
// export default '0.5.4.9'; // Fix RegisterAccount phone role bug
// export default '0.5.4.8'; // Disable InitialCallForm Submit button after pushing it
// export default '0.5.4.7'; // Add ability to download an account (first pass)
// export default '0.5.4.6'; // Change a few ObjectResult's to OkObjectResult's
// export default '0.5.4.5'; // Fix Account Deletion issue
// export default '0.5.4.4'; // Fix Account Registration issues
// export default '0.5.4.3'; // Add UI to set 'Sales Line' phone number for Accounts
// export default '0.5.4.2'; // Add Firm as possible Phone Owner
// export default '0.5.4.1'; // Add Duration to CallRailCall Record
// export default '0.5.4.0'; // Support CallRail Configuration
// export default '0.5.3.1'; // Ownership of Contacts; no Job Title for Practitioners
// export default '0.5.3.0'; // Some Sync, some responsive UI, enhnace spreadsheet upload
// export default '0.5.2.5'; // More self-contained Address Panel
// export default '0.5.2.4'; // Reflow Case Page
// export default '0.5.2.3'; // Remove unused files
// export default '0.5.2.2'; // Single Tab line in Settings
// export default '0.5.2.1'; // Fix bug in StateSelector onChange
// export default '0.5.2.0'; // Add eslint and fix a few warnings
// export default "0.5.1.12" // Remove all use of react-select in favor of Material-UI version
// export default "0.5.1.11" // Remove all use of react-autocomplete in favor of Material-UI version
// export default "0.5.1.10" // Better horizontal alignment in InitialCallPage
// export default "0.5.1.9" // Eliminate weird alignment in Campaign Modal
// export default "0.5.1.8" // Tighten up margins and padding in main page area
// export default "0.5.1.7" // Newly specified WebLink should not appear in orange
// export default "0.5.1.6" // Remove unsightly gray rectangle in Referral Company Page
// export default "0.5.1.5" // In NewDocsModal, Clear button no longer removes Document Type dropdown
// export default "0.5.1.4" // Make Autocomplete results show up in front of other page content
// export default "0.5.1.3" // Add Subhash
// export default "0.5.1.2" // Responsiveness for some dialogs, and better InitialCallPage
// export default "0.5.1.1" // Implement responsiveness in most top-level pages
// export default "0.5.1.0" // Include an App Bar and toggle NavBar for narrow windows
// export default "0.5.0.9" // Remove nearly all uses of GridContainer and GridItem
// export default "0.5.0.8" // Upgrade npm packages
// export default "0.5.0.7" // Small UI glitch fixes
// export default "0.5.0.6" // Make table sorting more robust to different types of data
// export default "0.5.0.5" // Simple possible fix to 'Unauthenticated' bug; Sticky headers in page-sized tables
// export default "0.5.0.4" // Fix z-index issues with New Document modal Type dropdown
// export default "0.5.0.3" // Fix tiny UI issues in Document Preview Modal
// export default "0.5.0.2" // Fix 2 bugs: Referral Notes; authorship of Notes on Initial Call Form
// export default "0.5.0.1" // A few quick fixes to AlertModal related things.
// export default "0.5.0.0" // Removed the last of the browser-supplied modals.
// export default "0.4.8.0" // Removed tons of browser-supplied modals; Tons or UI cleanup
// export default "0.4.7.6" // Load Inquiries whenever navigating to Inquiries page
// export default "0.4.7.5" // Reinstate better null handling in InquiryController; retain Inquiry-compatible ValidateKey
// export default "0.4.7.4" // Revert null handling in InquiryController
// export default "0.4.7.3" // Revert ValidateKey code in Startup.cs
// export default "0.4.7.2" // Revert null handling in InquiryController
// export default "0.4.7.1" // Fix ICF bug and hide 'Init Dropdowns' button
// export default "0.4.7.0" // Include Synch Controller
// export default "0.4.6.8" // Make a URL more RESTful
// export default "0.4.6.7" // Kludges to make Emergency Contact inactivity survive logout/login
// export default "0.4.6.6" // Add Inactive column to ClientContact table
// export default "0.4.6.5" // In converting Website-origin Inquiries to Referrals, correctly mark Comunnication Typs as 'Web Inquiry'
// export default "0.4.6.4" // Avoid storing 'null' in Inquiries ExtraJson
// export default "0.4.6.3" // Make Inquiry conversion to Emergency Contact work again
// export default "0.4.6.2" // Better Inquiry conversion
// export default "0.4.6.1" // Force temporal ordering of start/end of Campaign
// export default "0.4.6.0" // Add Emergence Contact Face Page
// export default "0.4.5.1" // Simplify color handling in PhoneInput
// export default "0.4.5.0" // Let User define new  Primary Insurance Carrier
// export default "0.4.4.2" // Don't try to show ancient dates in LabeledDatePicker
// export default "0.4.4.0" // Add Activity types: Tour, Schedule Assessment, and Complete Assessment
// export default "0.4.3.2" // Add inputs for Birthday, Gender, and Admission Date to Case Page
// export default "0.4.3.1" // Add inputs for Contact 'Job Title' (or 'Relationship') and 'Description' in several places
// export default "0.4.3.0" // Get Texting working properly
// export default "0.4.2.13" // Add SuperAdmin password resetting
// export default "0.4.2.12" // Rationalize buttons on VOB form
// export default "0.4.2.11" // Give charts more flexible width
// export default "0.4.2.10" // Remove 'Treatments' section from Initial Call Form
// export default "0.4.2.9" // Remove glitchy behavior of login page at certain browser widths
// export default "0.4.2.8" // Eliminate gray area at bottom of Case Page
// export default "0.4.2.7" // Full implementation of Top Referral Sources graph
// export default "0.4.2.6" // Save WebLink in new Referrer Org
// export default "0.4.2.5" // Minor superficial fixes
// export default "0.4.2.4" // Fix bug in toggling Contact In/Active
// export default "0.4.2.3" // Auto-select new Company Contact in Initial Call Form
// export default "0.4.2.2" // Add placeholder chart
// export default "0.4.2.1" // Fix missing website and phone number info
// export default "0.4.2.0" // Dashboard activity graph, many bug fixes
// export default "0.4.1.2" // Import works on New Paragigm spreadsheet
// export default "0.4.1.1" // Merge Contacts, small fixes, Better Import
// export default "0.4.1.0" // Avoid Company Contact duplicates
// export default "0.4.0.9" // Fix CRM-214 & CRM-215, showing contact-related tasks and counting tasks right
// export default "0.4.0.8" // Fix CRM-213, make unassigned Tasks deletable
// export default "0.4.0.7" // Fix CRM-150-a, load enough for Dashboard to know about emergency contact-assigned Tasks
// export default "0.4.0.6" // Fix CRM-186, changing Task due date
// export default "0.4.0.5" // Fix CRM-194, testing fields for null
// export default "0.4.0.4" // Fix CRM-193, allowing deletion of phone number of newly created Referral Contact
// export default "0.4.0.3" // Fix CRM-187 by prohibiting editing of Dropdown Items
// export default "0.4.0.2" // Hide two SuperAdmin buttons and the ReferralContact conversion option
// export default "0.4.0.1" // Fix CRM-190, Editing of Referral Company Address
// export default "0.4.0.0" // Implement CRM-181: Implement conversion of Inquiries to Prospects or Emergency Contacts
// export default "0.3.9.2" // Fix CRM-185: Editing Address (before providing phone number) of Company => 500 Error
// export default "0.3.9.1" // Retain Filter state across page changes
// export default "0.3.9.0" // Enable Active/Inactive Referral Contacts
// export default "0.3.8.9" // Protect most Dropdown Items from deletion
// export default "0.3.8.8" // Don't let Admin log in as User
// export default "0.3.8.7" // Speed up enhancing as Contact structs
// export default "0.3.8.6" // More speed, for VisibleFirms
// export default "0.3.8.5" // Fix spelling of 'AssigneeId'
// export default "0.3.8.4" // A little more speedup
// export default "0.3.8.3" // Loads of login speedups, orange buttons, VoB improvement, various fixes
// export default "0.3.8.2" // Fix crashing bug when Searching on Prospects page
// export default "0.3.8.1" // Make new Referral show up after filling in InitialCallForm
// export default "0.3.8.0" // Major Loading speedups. UI Enhancements
// export default "0.3.7.7" // Fix Provider Registration bug, clickaway bug. Add company Website. Other fixes
// export default "0.3.7.6" // support edit/delete of Notes and Activity Records
// export default "0.3.7.5" // enhancements to loading performance
// export default "0.3.7.4" // Start fixing Sex field
// export default "0.3.7.3" // Let Document Manager upload multiple documents at once
// export default "0.3.7.1" // Small enhancements to DocumentController
// export default "0.3.7.0" // API and DB Support for Stored Documents
// export default "0.3.6.17" // Functioning RandomSeeder
// export default "0.3.6.16" // Small UI and compiler cleanups
// export default "0.3.6.15" // On Refferer Org page, for newly created org, show Address, etc.
// export default "0.3.6.14" // In New Referrer Org Modal, sprinkle well-formatted phone numbers
// export default "0.3.6.13" // Fix "blank contact" problem in New Referrer Org Modal
// export default "0.3.6.12" // Simplify some disabled TextFields
// export default "0.3.6.11" // Hide calendar after a date is chosen
// export default "0.3.6.10" // Fix bug: Crash when changing due date of existing Task
// export default "0.3.6.9" // Fix bug: Non-display of activities after refresh of Case Page
// export default "0.3.6.8" // Fix bug in saving address in Initial Call Page
// export default "0.3.6.7" // Don't send an email when creating a demo
// export default "0.3.6.6" // Clear NewReferrerOrg Modal upon successful submission
// export default "0.3.6.5" // When logging phone call, etc, update "Last Contact"
// export default "0.3.6.4" // Trim name text inputs
// export default "0.3.6.3" // Introduce real (and extensible) options on VOB: Reimbursement Basis
// export default "0.3.6.2" // Don't automatically give API Key bearer SuperAdmin role
// export default "0.3.6.1" // Fix Personal Contact as Referrer bug
// export default "0.3.6.0" // Finish implementing API Key and Captcha validation support for Inquiry
// export default "0.3.5.2" // Simpler Inquiry API body
// export default "0.3.5.1" // On Idle Timeout, really log user out
// export default "0.3.5.0" // Finish Beta version of Alert capabilities
// export default "0.3.4.3" // Finished Alerts UI, except for global toggles
// export default "0.3.4.2" // Alerts in DB
// export default "0.3.4.1" // Small Patches
// export default "0.3.4.0" // Implement Inquiries Page and Inquiry Page
// export default "0.3.3.11" // Handle Firm ApiKey mapping in middleware
// export default "0.3.3.10" // API Key per Demo/Provider
// export default "0.3.3.9" // On Initial Call Form: Add "Other" to Org Contacts list, fixing CRM-51
// export default "0.3.3.8" // Fix a typo
// export default "0.3.3.7" // Implement Relative/Acquaintance>Other; fixing CRM-52
// export default "0.3.3.6" // Clean up a few Modals
// export default "0.3.3.5" // Simplify initialCallFormStyles and widen some dialogs
// export default "0.3.3.4" // Make modals at least a bit wider
// export default "0.3.3.3" // Fixed CRM-53 Select-campaign-crash.  Also restored labels on campaign dates
// export default "0.3.3.2" // Add Note functionality to ReferralPage
// export default "0.3.3.1" // ReferralPage complete except for Notes
// export default "0.3.3.0" // ReferralPage
// export default "0.3.2.10" // Better favicon
// export default "0.3.2.9" // Eliminate tons of compiler warnings
// export default "0.3.2.8" // Unify on PhoneInput2, step 2
// export default "0.3.2.7" // Unify on PhoneInput2
// export default "0.3.2.6" // Lots of upgrading and a few fixes
// export default "0.3.2.5" // Fix problem with autoselect of unique org contact
// export default "0.3.2.4" // Preclude changing from/to Private Practitioner to/from real Org
// export default "0.3.2.3" // Better DatePicker
// export default "0.3.2.2" // remove "no content yet" quasi-placeholder that can garble UI
// export default "0.3.2.3" // Hide "Copy FirmTypeName" button on SuperAdmin home page
// export default "0.3.2.1" // Invalidate Demo cache when we add/swapRoles/delete a User
// export default "0.3.2.0" // Increment version to reflect extensible Org Types functionality
// export default "0.3.1.15" // Remove Firm's FirmTypeName field
// export default "0.3.1.14" // Duplicate Firm's FirmTypeName field as FirmType
// export default "0.3.1.13" // New Logo: "[flag] alleva"
// export default "0.3.1.12" // Simplified Task Dialog
// export default "0.3.1.11" // Add console message when failing to log in
// export default "0.3.1.10" // In TimedOutModal, obscure password!
// export default "0.3.1.9" // In InitialCallForm change <form /> to <div /> to avoid gratuitous auto-complete
// export default "0.3.1.7" // Allow and Persist Sales Stage changes
// export default "0.3.1.6" // Fix bug in Campaign menu item selection
// export default "0.3.1.5" // On Sales Stage dropdown change Enrolled Client to Admitted Client
// export default "0.3.1.4" // Remove (bad) Search capability from Campaign Table
// export default "0.3.1.3" // Add Customizable Dropdown: Sales Stage
// export default "0.3.1.2" // Step three of Campaign implementation: better table layout
// export default "0.3.1.1" // Step two of Campaign implementation: Dialogs and API Calls
// export default "0.3.1.0" // Step one of Campaign implementation: Table
// export default "0.3.0.0" // Hide top header panel in al layouts
// export default "0.2.9.6" // Remove obsolete versions of VobForm
// export default "0.2.9.5" // Even more tweaks to VOB Form appearance
// export default "0.2.9.4" // More tweaks to VOB Form appearance
// export default "0.2.9.3" // Remove internal calls to endpoints from DbInit code
// export default "0.2.9.2" // Bigger tweaks to VOB Form appearance
// export default "0.2.9.1" // Small tweaks to VOB Form appearance
// export default "0.2.9.0" // Show VOB Form as Dialog rather than Drawer
// export default "0.2.8.8" // Add gray line separating assoc groups
// export default "0.2.8.7" // Add Settings Page and move Admin Control Room there
// export default "0.2.8.6" // Move Logout nav item inside collapsed User item
// export default "0.2.8.5" // Proper Idle Timeout time
// export default "0.2.8.3" // Proper Idle Timeout time
// export default "0.2.8.2" // Factor TimedOutModal into its own module
// export default "0.2.8.1" // After Idle Timeout Logout, got to Login
// export default "0.2.8.0" // Add Idle Timeout
// Remove trivial ways of closing Modals
// export default "0.2.7.2" // Simplified Task Creation (just one date mentioned)
// export default "0.2.7.1" // Single Address per Facility
// export default "0.2.7.0" // Full (recursively realized) implementation of Spreadsheet Upload
// export default "0.2.6.3" // Sort dropdown items before displaying them
// export default "0.2.6.2" // Handle Contacts on Client page a little more cleanly
// export default "0.2.6.1" // When setting/changing a Task deadline, round it and make succedding deadlines the same
// export default "0.2.6.0" // Implement Dropping of Referrer Companies & Practitioners. Fix InitialCallForm outdated handling of Practitioners
// export default "0.2.5.1" // Fix bug: adding or deleting a Company Contact didn't modify what was shown on the Companies page
// export default "0.2.5.0" // Full implementatoin of Customizable Dropdowns
// export default "0.2.3.0" // DB and Backend support for Customizable Dropdowns
// export default "0.2.2.4"
